import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=180ec56e&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"
import style0 from "./Register.vue?vue&type=style&index=0&id=180ec56e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../lianqiao-im/im-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180ec56e",
  null
  
)

export default component.exports